export {tokenResultAtom} from "../../store";

export  const userInfo ={
  email: '',
  name:'',
  id:''
}
/**
 * login parameter Info
 * @type {{password: string, id: string}}
 */
export const loginParams= {
  username: '',
  password: ''
}

export const loginAdminParams= {
  email: '',
  password: ''
}
// export const loginAdminParams= {
//   email: 'system@oaple.co.kr',
//   password: 'm@VLdu622x8R'
// }

export const adminInfo = {
  email: '',
  name:'',
  convertedUser: "",
  id: '',
  accountProfile: ''
}

export const findIdParams ={
  email: '',
  phone: ''
}

export const findIdResult = []

export const findPasswordParams ={
  phone: '',
  email: '',
  username: ''
}
